import { render, staticRenderFns } from "./SelectObjectAutocomplete.vue?vue&type=template&id=138d8969&scoped=true&"
import script from "./SelectObjectAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SelectObjectAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d8969",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
